'use client'

import { Avatar, Box, styled, Typography } from "@mui/material";



export const ContainerBox = styled(Box)(({ theme }) => ({
    width: '100%',
    maxWidth: "1136px",
    margin: "0 auto",
    minHeight: "100vh",
    padding: "16px 0",
    [theme.breakpoints.down('xl')]: {
        padding: "16px 3rem"
    }
}))


type profileDataProps = {
    onClick?: () => void;
    data: { first_name: string, last_name: string, description: string, img_src: string | null, img_alt?: string };
}

export const ProfileCard: React.FC<profileDataProps> = ({ onClick, data }) => {

    return (
        <Box onClick={onClick} className="w-full cursor-pointer hover:scale-105 transition-all max-w-[260px]">
            {data.img_src ? (
                <Box className="w-full max-w-[259px] overflow-hidden min-h-[259px] rounded-[50%]">
                    <img className="w-full object-cover h-[259px]" src={data.img_src} alt={data.img_alt} />
                </Box>
            ) : (
                <Avatar sx={{ margin: "0 auto", width: "100%", maxWidth: "259px", minHeight: "259px" }} />
            )}
            <Typography mt={2} variant="h5" textAlign={"center"} noWrap>
                {data.first_name}
            </Typography>
            <Typography variant="h5" textAlign={"center"} noWrap>
                {data.last_name}
            </Typography>
            <Typography mt={2} fontWeight={500} sx={{ color: "#9E640E", fontSize: '14px' }} textAlign={"center"} noWrap>
                {data.description}
            </Typography>
        </Box>
    )
}


type cardIconBoxProps = {
    data: {
        id: number;
        title: string;
        detail: string;
        icon: React.ReactNode;
    }[]
}
export const CardIconBox: React.FC<cardIconBoxProps> = ({ data }) => {
    return (
        <Box className="w-full max-w-fit flex-wrap flex min-h-[80px] justify-start items-center gap-4">
            {data.map((list) => {
                return (
                    <Box className="flex justify-center items-center gap-3 h-full" key={list.id}>
                        <Box className="h-full">
                            {list.icon}
                        </Box>
                        <Box className="w-full flex justify-start flex-col items-start h-full">
                            <Typography sx={{ color: "#737373" }} variant="h5">
                                {list.title}
                            </Typography>
                            <Typography>
                                {list.detail}
                            </Typography>
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}